import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilm } from "@fortawesome/free-solid-svg-icons";
import { NoRecordFound } from "../../../../components/Common/NoRecordFound";
import SubmitButton from "../../../../components/Common/SubmitButton";
import { VideoLinks } from "../TrainingVideos";

interface TrainingVideosFormProps {
  TrainingVideos: VideoLinks;
  handleInputChange: (key: string, value: string) => void;
  formatLabel: (key: string) => string;
  loader: boolean;
  disable: boolean;
  goBack: () => void;
}

const TrainingVideosForm: React.FC<TrainingVideosFormProps> = ({
  TrainingVideos,
  handleInputChange,
  formatLabel,
  loader,
  disable,
  goBack,
}) => {
  return (
    <div className="h-[17rem] md:h-[34rem]">
      <div className="flex flex-col gap-1">
        {TrainingVideos && Object.keys(TrainingVideos).length > 0 ? (
          Object.entries(TrainingVideos).map(([key, video]) => (
            <div key={key} className="p-4">
              <div>
                <label
                  htmlFor={`${key}-screen`}
                  className="block text-base font-bold text-gray-700"
                >
                  {formatLabel(key)}
                </label>

                <div className="relative flex items-center">
                  <input
                    id={`${key}-link`}
                    type="text"
                    value={video || ""}
                    onChange={(e) => handleInputChange(key, e.target.value)}
                    placeholder="Enter video link"
                    className="mt-1 h-11 p-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm md:text-base"
                  />
                  {video && (
                    <a
                      href={video}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="absolute right-3 top-1/2 transform -translate-y-1/2"
                    >
                      <FontAwesomeIcon
                        icon={faFilm}
                        className="text-2xl text-storylightgreen hover:text-green-600 transition-colors duration-200"
                      />
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))
        ) : (
          <NoRecordFound />
        )}
        <SubmitButton
          title="Save"
          loader={loader}
          disabled={disable}
          size={`${disable ? "opacity-50" : ""} w-full mx-4`}
          cancelOperation={goBack}
        />
      </div>
    </div>
  );
};

export default TrainingVideosForm;
